import React from "react";
import ImageSequence from "./ImageSequence";

const Image = ({ data, images }) => {
  if (images.sequence) {
    return <ImageSequence images={images.sequenceSources} />;
  }

  return (
    <picture>
      <source
        srcSet={require(`../images/${images.name}.webp`)}
        type="image/webp"
      />
      <source
        srcSet={require(`../images/${images.name}.jpg`)}
        type="image/jpeg"
      />
      <img
        className="app-image active"
        alt={images.imageAltText}
        src={require(`../images/${images.name}.jpg`)}
      />
    </picture>
  );
};

export default Image;
